/** ------------------------------------------------------------------------
 * Quantity input changed
 * ---------------------------------------------------------------------- */
var timer;

$('#quantity').on('change paste keyup', function () {
    timer && clearTimeout(timer);
    timer = setTimeout(function () {
        if ($('#quantity').val() <= minQtyToSell) {
            $('#quantity').val(minQtyToSell);
        }
    }, 2000);
});